// Auto-generated from CSV imports (Ene-Dic 2025 + Ene 2026)
// Total: 57 personas unicas, 94 mediciones
// Listos para asociacion manual uno-a-uno (tarjeta -> UID)
export const IMPORTED_DRAFTS = [
  {
    "id": "draft-001",
    "tarjeta": "WE360-830FF324",
    "nombres": "Madeline",
    "apellidos": "Arguello",
    "fechaNacimiento": "12/09/1997",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "25/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 25.6,
        "cintura": null,
        "paSistolica": 110,
        "paDiastolica": 68,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "28/01/2025",
        "source": "Enero 2025",
        "peso": null,
        "talla": null,
        "imc": 24.1,
        "cintura": null,
        "paSistolica": 117,
        "paDiastolica": 81,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "25/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 25.6,
      "cintura": null,
      "paSistolica": 110,
      "paDiastolica": 68,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-002",
    "tarjeta": "WE360-032F7F35",
    "nombres": "María Fernanda",
    "apellidos": "Urdaneta Padrón",
    "fechaNacimiento": "09/02/2000",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "25/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 25.2,
        "cintura": null,
        "paSistolica": 90,
        "paDiastolica": 66,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "28/01/2025",
        "source": "Enero 2025",
        "peso": null,
        "talla": null,
        "imc": 24.6,
        "cintura": null,
        "paSistolica": null,
        "paDiastolica": null,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "25/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 25.2,
      "cintura": null,
      "paSistolica": 90,
      "paDiastolica": 66,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-003",
    "tarjeta": "WE360-43080B25",
    "nombres": "Gabriela",
    "apellidos": "Castro",
    "fechaNacimiento": "30/10/1987",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "02/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 25.7,
        "cintura": null,
        "paSistolica": 112,
        "paDiastolica": 82,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "30/01/2025",
        "source": "Enero 2025",
        "peso": null,
        "talla": null,
        "imc": 27.2,
        "cintura": null,
        "paSistolica": 121,
        "paDiastolica": 93,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "02/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 25.7,
      "cintura": null,
      "paSistolica": 112,
      "paDiastolica": 82,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-004",
    "tarjeta": "WE360-5382C015",
    "nombres": "German",
    "apellidos": "Torrealba",
    "fechaNacimiento": "30/04/1963",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "17/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 33.6,
        "cintura": null,
        "paSistolica": 120,
        "paDiastolica": 89,
        "glucemia": null,
        "oximetria": 95,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "17/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 33.6,
      "cintura": null,
      "paSistolica": 120,
      "paDiastolica": 89,
      "glucemia": null,
      "oximetria": 95,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-005",
    "tarjeta": "WE360-F3C36E35",
    "nombres": "Mariliz",
    "apellidos": "Saez",
    "fechaNacimiento": "29/10/1990",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "09/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 30.1,
        "cintura": null,
        "paSistolica": 129,
        "paDiastolica": 82,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "07/08/2025",
        "source": "Agosto 2025",
        "peso": null,
        "talla": null,
        "imc": null,
        "cintura": null,
        "paSistolica": 141,
        "paDiastolica": 97,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "08/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 28.2,
        "cintura": null,
        "paSistolica": 135,
        "paDiastolica": 100,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "06/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 30.4,
        "cintura": null,
        "paSistolica": 167,
        "paDiastolica": 107,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "09/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 30.1,
      "cintura": null,
      "paSistolica": 129,
      "paDiastolica": 82,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 4
  },
  {
    "id": "draft-006",
    "tarjeta": "WE360-058BF903",
    "nombres": "Katerine",
    "apellidos": "Taylor",
    "fechaNacimiento": "02/08/1990",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "17/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 33.8,
        "cintura": null,
        "paSistolica": 121,
        "paDiastolica": 90,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "17/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 33.8,
      "cintura": null,
      "paSistolica": 121,
      "paDiastolica": 90,
      "glucemia": null,
      "oximetria": 98,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-007",
    "tarjeta": "WE360-37B8F803",
    "nombres": "María",
    "apellidos": "Moran Rivera",
    "fechaNacimiento": "13/03/1977",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "26/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 28.5,
        "cintura": null,
        "paSistolica": 100,
        "paDiastolica": 77,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "26/06/2025",
        "source": "Junio 2025",
        "peso": null,
        "talla": null,
        "imc": 29.4,
        "cintura": null,
        "paSistolica": 112,
        "paDiastolica": 77,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "17/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 28.7,
        "cintura": null,
        "paSistolica": 121,
        "paDiastolica": 81,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "",
        "source": "Agosto 2025",
        "peso": null,
        "talla": null,
        "imc": null,
        "cintura": null,
        "paSistolica": 109,
        "paDiastolica": 78,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "26/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 28.5,
      "cintura": null,
      "paSistolica": 100,
      "paDiastolica": 77,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 4
  },
  {
    "id": "draft-008",
    "tarjeta": "WE360-S360F803",
    "nombres": "Manuela",
    "apellidos": "Jimenez",
    "fechaNacimiento": "07/03/1997",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "25/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 25.6,
        "cintura": null,
        "paSistolica": 102,
        "paDiastolica": 70,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "11/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 26.8,
        "cintura": null,
        "paSistolica": 101,
        "paDiastolica": 68,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "18/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 27.7,
        "cintura": null,
        "paSistolica": 112,
        "paDiastolica": 73,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "25/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 25.6,
      "cintura": null,
      "paSistolica": 102,
      "paDiastolica": 70,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 3
  },
  {
    "id": "draft-009",
    "tarjeta": "WE360-318EF903",
    "nombres": "Carlos Eduardo",
    "apellidos": "Urdaneta Padrón",
    "fechaNacimiento": "15/03/1980",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "08/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 26.1,
        "cintura": null,
        "paSistolica": 129,
        "paDiastolica": 84,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "18/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 26.1,
        "cintura": null,
        "paSistolica": 133,
        "paDiastolica": 87,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "08/07/2025",
      "source": "Julio 2025",
      "peso": null,
      "talla": null,
      "imc": 26.1,
      "cintura": null,
      "paSistolica": 129,
      "paDiastolica": 84,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-010",
    "tarjeta": "WE360-5D7CF803",
    "nombres": "Diana",
    "apellidos": "Rodriguez Molina",
    "fechaNacimiento": "22/05/1991",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "04/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 27.9,
        "cintura": null,
        "paSistolica": 103,
        "paDiastolica": 74,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "11/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 29.3,
        "cintura": null,
        "paSistolica": 110,
        "paDiastolica": 77,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "18/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 29.7,
        "cintura": null,
        "paSistolica": 128,
        "paDiastolica": 97,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "04/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 27.9,
      "cintura": null,
      "paSistolica": 103,
      "paDiastolica": 74,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 3
  },
  {
    "id": "draft-011",
    "tarjeta": "WE360-43A69734",
    "nombres": "Isis",
    "apellidos": "Corrales",
    "fechaNacimiento": "25/07/1997",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "18/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 20.9,
        "cintura": null,
        "paSistolica": 97,
        "paDiastolica": 67,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "18/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 20.9,
      "cintura": null,
      "paSistolica": 97,
      "paDiastolica": 67,
      "glucemia": null,
      "oximetria": 100,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-012",
    "tarjeta": "WE360-23876D35",
    "nombres": "Jesús Alfredo",
    "apellidos": "Torres Bastidas",
    "fechaNacimiento": "09/04/2002",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "18/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 26.9,
        "cintura": null,
        "paSistolica": 140,
        "paDiastolica": 93,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "18/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 26.9,
      "cintura": null,
      "paSistolica": 140,
      "paDiastolica": 93,
      "glucemia": null,
      "oximetria": 99,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-013",
    "tarjeta": "WE360-373CF903",
    "nombres": "Eduardo",
    "apellidos": "Chung",
    "fechaNacimiento": "03/10/1999",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 33.7,
        "cintura": null,
        "paSistolica": 120,
        "paDiastolica": 86,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "20/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 33.7,
      "cintura": null,
      "paSistolica": 120,
      "paDiastolica": 86,
      "glucemia": null,
      "oximetria": 98,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-014",
    "tarjeta": "WE360-4579FA03",
    "nombres": "Julio",
    "apellidos": "Rodriguez",
    "fechaNacimiento": "13/10/1994",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 32.5,
        "cintura": null,
        "paSistolica": 117,
        "paDiastolica": 89,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "20/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 32.5,
      "cintura": null,
      "paSistolica": 117,
      "paDiastolica": 89,
      "glucemia": null,
      "oximetria": 98,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-015",
    "tarjeta": "WE360-5486F903",
    "nombres": "Luis",
    "apellidos": "Hibarguen",
    "fechaNacimiento": "30/05/1998",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "26/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 26.1,
        "cintura": null,
        "paSistolica": 107,
        "paDiastolica": 70,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 27.1,
        "cintura": null,
        "paSistolica": 111,
        "paDiastolica": 74,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "26/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 26.1,
      "cintura": null,
      "paSistolica": 107,
      "paDiastolica": 70,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-016",
    "tarjeta": "WE360-E138F903",
    "nombres": "Yairemis",
    "apellidos": "Armuelles",
    "fechaNacimiento": "27/08/2001",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "26/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 27.5,
        "cintura": null,
        "paSistolica": 83,
        "paDiastolica": 61,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 26.2,
        "cintura": null,
        "paSistolica": 94,
        "paDiastolica": 71,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "26/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 27.5,
      "cintura": null,
      "paSistolica": 83,
      "paDiastolica": 61,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-017",
    "tarjeta": "WE360-B3D99F34",
    "nombres": "Barbara",
    "apellidos": "Marino",
    "fechaNacimiento": "02/10/1978",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "02/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 26.3,
        "cintura": null,
        "paSistolica": 110,
        "paDiastolica": 75,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 27.8,
        "cintura": null,
        "paSistolica": 104,
        "paDiastolica": 79,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "02/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 26.3,
      "cintura": null,
      "paSistolica": 110,
      "paDiastolica": 75,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-018",
    "tarjeta": "WE360-13D6035",
    "nombres": "Mariana",
    "apellidos": "Calvo",
    "fechaNacimiento": "11/09/1997",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "02/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 24.8,
        "cintura": null,
        "paSistolica": 93,
        "paDiastolica": 64,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "08/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 26.4,
        "cintura": null,
        "paSistolica": 98,
        "paDiastolica": 66,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 26.6,
        "cintura": null,
        "paSistolica": 99,
        "paDiastolica": 64,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "02/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 24.8,
      "cintura": null,
      "paSistolica": 93,
      "paDiastolica": 64,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 3
  },
  {
    "id": "draft-019",
    "tarjeta": "WE360-1E2BFA03",
    "nombres": "Rafael",
    "apellidos": "Ramos",
    "fechaNacimiento": "19/06/1989",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "11/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 27.4,
        "cintura": null,
        "paSistolica": 110,
        "paDiastolica": 64,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 28.0,
        "cintura": null,
        "paSistolica": 115,
        "paDiastolica": 75,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "11/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 27.4,
      "cintura": null,
      "paSistolica": 110,
      "paDiastolica": 64,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-020",
    "tarjeta": "WE360-13579D34",
    "nombres": "Daniel",
    "apellidos": "Sanchez",
    "fechaNacimiento": "04/09/1996",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "18/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 33.0,
        "cintura": null,
        "paSistolica": 132,
        "paDiastolica": 84,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "20/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 29.5,
        "cintura": null,
        "paSistolica": 124,
        "paDiastolica": 83,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "18/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 33.0,
      "cintura": null,
      "paSistolica": 132,
      "paDiastolica": 84,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-021",
    "tarjeta": "WE360-83687F35",
    "nombres": "Ivan Lenín",
    "apellidos": "Serrano Terrientes",
    "fechaNacimiento": "27/08/2001",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "26/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 29.5,
        "cintura": null,
        "paSistolica": 119,
        "paDiastolica": 84,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 27.5,
        "cintura": null,
        "paSistolica": 109,
        "paDiastolica": 65,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "26/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 29.5,
      "cintura": null,
      "paSistolica": 119,
      "paDiastolica": 84,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-022",
    "tarjeta": "WE30-5EDBF903",
    "nombres": "Miguel Dario",
    "apellidos": "Noeschese Acuña",
    "fechaNacimiento": "12/02/1988",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "10/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 30.4,
        "cintura": null,
        "paSistolica": 114,
        "paDiastolica": 71,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 30.7,
        "cintura": null,
        "paSistolica": 108,
        "paDiastolica": 73,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "10/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 30.4,
      "cintura": null,
      "paSistolica": 114,
      "paDiastolica": 71,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-023",
    "tarjeta": "WE360-63FDF604",
    "nombres": "Karina del Carmen",
    "apellidos": "Cachucho Pereira",
    "fechaNacimiento": "03/12/1988",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 19.5,
        "cintura": null,
        "paSistolica": 115,
        "paDiastolica": 70,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "21/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 19.5,
      "cintura": null,
      "paSistolica": 115,
      "paDiastolica": 70,
      "glucemia": null,
      "oximetria": 99,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-024",
    "tarjeta": "WE360-230B9235",
    "nombres": "Nazareth Valentina",
    "apellidos": "Salazar Mariño",
    "fechaNacimiento": "14/02/1993",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "16/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 26.4,
        "cintura": null,
        "paSistolica": 102,
        "paDiastolica": 65,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 25.3,
        "cintura": null,
        "paSistolica": 107,
        "paDiastolica": 64,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "16/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 26.4,
      "cintura": null,
      "paSistolica": 102,
      "paDiastolica": 65,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-025",
    "tarjeta": "WE360-93240D25",
    "nombres": "Celso Enrique",
    "apellidos": "Mejìa Pino",
    "fechaNacimiento": "13/08/1994",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 15.2,
        "cintura": null,
        "paSistolica": 113,
        "paDiastolica": 74,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "21/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 15.2,
      "cintura": null,
      "paSistolica": 113,
      "paDiastolica": 74,
      "glucemia": null,
      "oximetria": 98,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-026",
    "tarjeta": "WE360-F3A26935",
    "nombres": "Mallely Naizareth",
    "apellidos": "Coronado Duran",
    "fechaNacimiento": "25/05/1986",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 26.8,
        "cintura": null,
        "paSistolica": 112,
        "paDiastolica": 86,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "21/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 26.8,
      "cintura": null,
      "paSistolica": 112,
      "paDiastolica": 86,
      "glucemia": null,
      "oximetria": 99,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-027",
    "tarjeta": "WE360-83459C34",
    "nombres": "Margelis Gabriela",
    "apellidos": "Ortiz Castellar",
    "fechaNacimiento": "24/03/1992",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 21.4,
        "cintura": null,
        "paSistolica": 88,
        "paDiastolica": 62,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "21/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 21.4,
      "cintura": null,
      "paSistolica": 88,
      "paDiastolica": 62,
      "glucemia": null,
      "oximetria": 99,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-028",
    "tarjeta": "WE360-EE79F803",
    "nombres": "Alejandra",
    "apellidos": "Rodriguez Gonzalez",
    "fechaNacimiento": "09/12/1987",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "11/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": null,
        "cintura": null,
        "paSistolica": 118,
        "paDiastolica": 68,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "21/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 22.8,
        "cintura": null,
        "paSistolica": 110,
        "paDiastolica": 62,
        "glucemia": null,
        "oximetria": 97,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "11/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": null,
      "cintura": null,
      "paSistolica": 118,
      "paDiastolica": 68,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-029",
    "tarjeta": "WE360-5280F803",
    "nombres": "Arelys Aylin",
    "apellidos": "Paz Liendo",
    "fechaNacimiento": "26/07/2000",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "25/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 27.4,
        "cintura": null,
        "paSistolica": 121,
        "paDiastolica": 81,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "25/02/2025",
      "source": "Febrero 2025",
      "peso": null,
      "talla": null,
      "imc": 27.4,
      "cintura": null,
      "paSistolica": 121,
      "paDiastolica": 81,
      "glucemia": null,
      "oximetria": 99,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-030",
    "tarjeta": "WE360-9AB1F903",
    "nombres": "Melissa Raquel",
    "apellidos": "Maciá Gonzalez",
    "fechaNacimiento": "05/04/1995",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "17/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 20.9,
        "cintura": null,
        "paSistolica": 92,
        "paDiastolica": 73,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "25/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 19.9,
        "cintura": null,
        "paSistolica": 100,
        "paDiastolica": 74,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "17/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 20.9,
      "cintura": null,
      "paSistolica": 92,
      "paDiastolica": 73,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-031",
    "tarjeta": "WE360-F3F40725",
    "nombres": "Jesús Andrés",
    "apellidos": "Hoquee Estanziola",
    "fechaNacimiento": "28/02/2000",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "25/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 23.8,
        "cintura": null,
        "paSistolica": 114,
        "paDiastolica": 74,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "15/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 23.3,
        "cintura": null,
        "paSistolica": 126,
        "paDiastolica": 76,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "26/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 23.2,
        "cintura": null,
        "paSistolica": 127,
        "paDiastolica": 84,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "25/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 23.8,
      "cintura": null,
      "paSistolica": 114,
      "paDiastolica": 74,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 3
  },
  {
    "id": "draft-032",
    "tarjeta": "WE360-03CF9B34",
    "nombres": "Johana Isabel",
    "apellidos": "Padilla Rodriguez",
    "fechaNacimiento": "05/03/1990",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "25/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 18.6,
        "cintura": null,
        "paSistolica": 99,
        "paDiastolica": 68,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "03/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 18.7,
        "cintura": null,
        "paSistolica": 86,
        "paDiastolica": 66,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "26/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 17.5,
        "cintura": null,
        "paSistolica": 96,
        "paDiastolica": 67,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "25/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 18.6,
      "cintura": null,
      "paSistolica": 99,
      "paDiastolica": 68,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 3
  },
  {
    "id": "draft-033",
    "tarjeta": "WE360-73059334",
    "nombres": "Jesus Antonio",
    "apellidos": "Sanchez Ramirez",
    "fechaNacimiento": "19/07/1994",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "17/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 21.8,
        "cintura": null,
        "paSistolica": 123,
        "paDiastolica": 81,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "27/02/2025",
        "source": "Febrero 2025",
        "peso": null,
        "talla": null,
        "imc": 24.3,
        "cintura": null,
        "paSistolica": 116,
        "paDiastolica": 76,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "17/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 21.8,
      "cintura": null,
      "paSistolica": 123,
      "paDiastolica": 81,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-034",
    "tarjeta": "WE360-4327FA03",
    "nombres": "Kimberly",
    "apellidos": "Serrano Terrientes",
    "fechaNacimiento": "12/12/1997",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "06/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 38.6,
        "cintura": null,
        "paSistolica": 114,
        "paDiastolica": 87,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "06/03/2025",
      "source": "Marzo 2025",
      "peso": null,
      "talla": null,
      "imc": 38.6,
      "cintura": null,
      "paSistolica": 114,
      "paDiastolica": 87,
      "glucemia": null,
      "oximetria": 100,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-035",
    "tarjeta": "WE360-DE1FFA03",
    "nombres": "Gustavo",
    "apellidos": "Dejavorsky",
    "fechaNacimiento": "15/11/2005",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "06/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 24.2,
        "cintura": null,
        "paSistolica": 120,
        "paDiastolica": 77,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "06/03/2025",
      "source": "Marzo 2025",
      "peso": null,
      "talla": null,
      "imc": 24.2,
      "cintura": null,
      "paSistolica": 120,
      "paDiastolica": 77,
      "glucemia": null,
      "oximetria": 100,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-036",
    "tarjeta": "WE360-83D5EF24",
    "nombres": "Patricia",
    "apellidos": "Cardenas",
    "fechaNacimiento": "06/07/1996",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "06/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 23.4,
        "cintura": null,
        "paSistolica": 93,
        "paDiastolica": 65,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "06/03/2025",
      "source": "Marzo 2025",
      "peso": null,
      "talla": null,
      "imc": 23.4,
      "cintura": null,
      "paSistolica": 93,
      "paDiastolica": 65,
      "glucemia": null,
      "oximetria": 100,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-037",
    "tarjeta": "WE360-3B36FA03",
    "nombres": "Mónica",
    "apellidos": "Herrera Fergusson",
    "fechaNacimiento": "19/08/1983",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "07/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 38.5,
        "cintura": null,
        "paSistolica": 107,
        "paDiastolica": 86,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "07/03/2025",
      "source": "Marzo 2025",
      "peso": null,
      "talla": null,
      "imc": 38.5,
      "cintura": null,
      "paSistolica": 107,
      "paDiastolica": 86,
      "glucemia": null,
      "oximetria": 98,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-038",
    "tarjeta": "WE360-15C9F903",
    "nombres": "Patricia",
    "apellidos": "Mora Crespo",
    "fechaNacimiento": "21/09/1987",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "19/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 20.9,
        "cintura": null,
        "paSistolica": 100,
        "paDiastolica": 76,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "17/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 19.7,
        "cintura": null,
        "paSistolica": 115,
        "paDiastolica": 79,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "11/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 19.7,
        "cintura": null,
        "paSistolica": 115,
        "paDiastolica": 79,
        "glucemia": null,
        "oximetria": 100,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "19/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 20.9,
      "cintura": null,
      "paSistolica": 100,
      "paDiastolica": 76,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 3
  },
  {
    "id": "draft-039",
    "tarjeta": "WE360-C1DEF803",
    "nombres": "Luis Alberto",
    "apellidos": "Marquinez Pinzón",
    "fechaNacimiento": "20/04/1981",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "12/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 39.8,
        "cintura": null,
        "paSistolica": 145,
        "paDiastolica": 96,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "12/03/2025",
      "source": "Marzo 2025",
      "peso": null,
      "talla": null,
      "imc": 39.8,
      "cintura": null,
      "paSistolica": 145,
      "paDiastolica": 96,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-040",
    "tarjeta": "WE360-598BF903",
    "nombres": "Arleny Mariam",
    "apellidos": "Marcos Acuña",
    "fechaNacimiento": "30/08/1995",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "13/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 20.0,
        "cintura": null,
        "paSistolica": 94,
        "paDiastolica": 65,
        "glucemia": null,
        "oximetria": 99,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "13/03/2025",
      "source": "Marzo 2025",
      "peso": null,
      "talla": null,
      "imc": 20.0,
      "cintura": null,
      "paSistolica": 94,
      "paDiastolica": 65,
      "glucemia": null,
      "oximetria": 99,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-041",
    "tarjeta": "WE360-3548F903",
    "nombres": "Jeffrey Raúl",
    "apellidos": "Carranza Mendez",
    "fechaNacimiento": "29/07/1995",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "14/03/2025",
        "source": "Marzo 2025",
        "peso": null,
        "talla": null,
        "imc": 22.7,
        "cintura": null,
        "paSistolica": 132,
        "paDiastolica": 76,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "14/03/2025",
      "source": "Marzo 2025",
      "peso": null,
      "talla": null,
      "imc": 22.7,
      "cintura": null,
      "paSistolica": 132,
      "paDiastolica": 76,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-042",
    "tarjeta": "WE360-A33D1435",
    "nombres": "Sarai Estela",
    "apellidos": "Guerra Díaz",
    "fechaNacimiento": "10/02/2000",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "03/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 24.5,
        "cintura": null,
        "paSistolica": 92,
        "paDiastolica": 72,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "03/07/2025",
      "source": "Julio 2025",
      "peso": null,
      "talla": null,
      "imc": 24.5,
      "cintura": null,
      "paSistolica": 92,
      "paDiastolica": 72,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-043",
    "tarjeta": "WE360-03020525",
    "nombres": "Margory Ailyn",
    "apellidos": "Rodriguez PIneda",
    "fechaNacimiento": "18/06/1992",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "25/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 38.1,
        "cintura": null,
        "paSistolica": 110,
        "paDiastolica": 71,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "08/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 37.1,
        "cintura": null,
        "paSistolica": 100,
        "paDiastolica": 67,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "25/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 38.1,
      "cintura": null,
      "paSistolica": 110,
      "paDiastolica": 71,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-044",
    "tarjeta": "WE360-7E9EF903",
    "nombres": "Pablo Andrés",
    "apellidos": "Barón Cardozo",
    "fechaNacimiento": "19/10/1975",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "18/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 28.0,
        "cintura": null,
        "paSistolica": 124,
        "paDiastolica": 81,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "03/09/2025",
        "source": "Septiembre 2025",
        "peso": null,
        "talla": null,
        "imc": null,
        "cintura": null,
        "paSistolica": null,
        "paDiastolica": null,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "11/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 28.2,
        "cintura": null,
        "paSistolica": 133,
        "paDiastolica": 79,
        "glucemia": null,
        "oximetria": 98,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "18/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 28.0,
      "cintura": null,
      "paSistolica": 124,
      "paDiastolica": 81,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 3
  },
  {
    "id": "draft-045",
    "tarjeta": "WE360-220DF903",
    "nombres": "Luís Enrique",
    "apellidos": "Villarreal Quintana",
    "fechaNacimiento": "15/10/1978",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "15/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 30.9,
        "cintura": null,
        "paSistolica": 112,
        "paDiastolica": 78,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "15/07/2025",
      "source": "Julio 2025",
      "peso": null,
      "talla": null,
      "imc": 30.9,
      "cintura": null,
      "paSistolica": 112,
      "paDiastolica": 78,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-046",
    "tarjeta": "WE360-539E1025",
    "nombres": "Luz Marina",
    "apellidos": "Sambrano",
    "fechaNacimiento": "15/09/1995",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "15/07/2025",
        "source": "Julio 2025",
        "peso": null,
        "talla": null,
        "imc": 26.2,
        "cintura": null,
        "paSistolica": 94,
        "paDiastolica": 66,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "15/07/2025",
      "source": "Julio 2025",
      "peso": null,
      "talla": null,
      "imc": 26.2,
      "cintura": null,
      "paSistolica": 94,
      "paDiastolica": 66,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-047",
    "tarjeta": "",
    "nombres": "Rolando",
    "apellidos": "Valdes Ramos",
    "fechaNacimiento": "12/06/1995",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "07/08/2025",
        "source": "Agosto 2025",
        "peso": null,
        "talla": null,
        "imc": 25.5,
        "cintura": null,
        "paSistolica": 128,
        "paDiastolica": 85,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "07/08/2025",
      "source": "Agosto 2025",
      "peso": null,
      "talla": null,
      "imc": 25.5,
      "cintura": null,
      "paSistolica": 128,
      "paDiastolica": 85,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-048",
    "tarjeta": "",
    "nombres": "Diomar",
    "apellidos": "Dionovan Mosquera",
    "fechaNacimiento": "19/10/1998",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "07/08/2025",
        "source": "Agosto 2025",
        "peso": null,
        "talla": null,
        "imc": 37.8,
        "cintura": null,
        "paSistolica": 116,
        "paDiastolica": 79,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "07/08/2025",
      "source": "Agosto 2025",
      "peso": null,
      "talla": null,
      "imc": 37.8,
      "cintura": null,
      "paSistolica": 116,
      "paDiastolica": 79,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-049",
    "tarjeta": "",
    "nombres": "José Alonso",
    "apellidos": "Suarez Prado",
    "fechaNacimiento": "08/02/2007",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "28/08/2025",
        "source": "Agosto 2025",
        "peso": null,
        "talla": null,
        "imc": 18.6,
        "cintura": null,
        "paSistolica": 100,
        "paDiastolica": 62,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "28/08/2025",
      "source": "Agosto 2025",
      "peso": null,
      "talla": null,
      "imc": 18.6,
      "cintura": null,
      "paSistolica": 100,
      "paDiastolica": 62,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-050",
    "tarjeta": "",
    "nombres": "Brandon José",
    "apellidos": "Mes Wright",
    "fechaNacimiento": "16/08/2004",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "18/09/2025",
        "source": "Septiembre 2025",
        "peso": null,
        "talla": null,
        "imc": 25.5,
        "cintura": null,
        "paSistolica": 128,
        "paDiastolica": 85,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "18/09/2025",
      "source": "Septiembre 2025",
      "peso": null,
      "talla": null,
      "imc": 25.5,
      "cintura": null,
      "paSistolica": 128,
      "paDiastolica": 85,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-051",
    "tarjeta": "",
    "nombres": "Bárbara",
    "apellidos": "Rangel Freites",
    "fechaNacimiento": "14/11/2002",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "26/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 25.2,
        "cintura": null,
        "paSistolica": 102,
        "paDiastolica": 73,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      },
      {
        "date": "18/09/2025",
        "source": "Septiembre 2025",
        "peso": null,
        "talla": null,
        "imc": 24.9,
        "cintura": null,
        "paSistolica": null,
        "paDiastolica": null,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "26/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 25.2,
      "cintura": null,
      "paSistolica": 102,
      "paDiastolica": 73,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 2
  },
  {
    "id": "draft-052",
    "tarjeta": "",
    "nombres": "María Fernanda",
    "apellidos": "Moreno Sanchez",
    "fechaNacimiento": "01/10/2004",
    "sexo": "Femenino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "18/09/2025",
        "source": "Septiembre 2025",
        "peso": null,
        "talla": null,
        "imc": 21.7,
        "cintura": null,
        "paSistolica": 107,
        "paDiastolica": 75,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "18/09/2025",
      "source": "Septiembre 2025",
      "peso": null,
      "talla": null,
      "imc": 21.7,
      "cintura": null,
      "paSistolica": 107,
      "paDiastolica": 75,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-053",
    "tarjeta": "",
    "nombres": "Arath Yabir",
    "apellidos": "Casas Garcia",
    "fechaNacimiento": "22/08/2003",
    "sexo": "Masculino",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "30/09/2025",
        "source": "Septiembre 2025",
        "peso": null,
        "talla": null,
        "imc": 26.0,
        "cintura": null,
        "paSistolica": 133,
        "paDiastolica": 80,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "30/09/2025",
      "source": "Septiembre 2025",
      "peso": null,
      "talla": null,
      "imc": 26.0,
      "cintura": null,
      "paSistolica": 133,
      "paDiastolica": 80,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-054",
    "tarjeta": "",
    "nombres": "Katehrine",
    "apellidos": "Taylor",
    "fechaNacimiento": "02/08/1990",
    "sexo": "",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "26/11/2025",
        "source": "Noviembre 2025",
        "peso": null,
        "talla": null,
        "imc": 33.3,
        "cintura": null,
        "paSistolica": 119,
        "paDiastolica": 87,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "26/11/2025",
      "source": "Noviembre 2025",
      "peso": null,
      "talla": null,
      "imc": 33.3,
      "cintura": null,
      "paSistolica": 119,
      "paDiastolica": 87,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-055",
    "tarjeta": "",
    "nombres": "José Alberto",
    "apellidos": "Serrud Barsello",
    "fechaNacimiento": "10/08/2006",
    "sexo": "",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "02/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 34.0,
        "cintura": null,
        "paSistolica": 133,
        "paDiastolica": 83,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "02/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 34.0,
      "cintura": null,
      "paSistolica": 133,
      "paDiastolica": 83,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-056",
    "tarjeta": "",
    "nombres": "Juliet Meribeth",
    "apellidos": "Alvarez Chacon",
    "fechaNacimiento": "11/09/1990",
    "sexo": "",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "09/12/2025",
        "source": "Diciembre 2025",
        "peso": null,
        "talla": null,
        "imc": 24.5,
        "cintura": null,
        "paSistolica": 103,
        "paDiastolica": 72,
        "glucemia": null,
        "oximetria": null,
        "fc": null,
        "condicionTexto": null,
        "status": null,
        "edad": null
      }
    ],
    "latestMeasurement": {
      "date": "09/12/2025",
      "source": "Diciembre 2025",
      "peso": null,
      "talla": null,
      "imc": 24.5,
      "cintura": null,
      "paSistolica": 103,
      "paDiastolica": 72,
      "glucemia": null,
      "oximetria": null,
      "fc": null,
      "condicionTexto": null,
      "status": null,
      "edad": null
    },
    "totalMeasurements": 1
  },
  {
    "id": "draft-057",
    "tarjeta": "",
    "nombres": "Ana Michelle",
    "apellidos": "Barría Díaz",
    "fechaNacimiento": "20/09/2005",
    "sexo": "",
    "email": null,
    "status": "borrador",
    "linkedUid": null,
    "measurements": [
      {
        "date": "15/01/2026",
        "source": "Enero 2026",
        "peso": 48.1,
        "talla": 156.5,
        "imc": 19.6,
        "cintura": 65,
        "paSistolica": 104,
        "paDiastolica": 76,
        "glucemia": 74,
        "oximetria": null,
        "fc": 78,
        "condicionTexto": null,
        "status": "Ingreso",
        "edad": 20
      }
    ],
    "latestMeasurement": {
      "date": "15/01/2026",
      "source": "Enero 2026",
      "peso": 48.1,
      "talla": 156.5,
      "imc": 19.6,
      "cintura": 65,
      "paSistolica": 104,
      "paDiastolica": 76,
      "glucemia": 74,
      "oximetria": null,
      "fc": 78,
      "condicionTexto": null,
      "status": "Ingreso",
      "edad": 20
    },
    "totalMeasurements": 1
  }
];
